import { useTranslation } from 'react-i18next'

import { ConsentsForm } from '@ana/shared'
import { Form } from '@ana/shared'
import PageLayout from 'components/PageLayout'
import ClinicEntity from 'entities/Clinic'
import { useAnswers } from 'providers/AnswersProvider'

import usePage from '../../hooks/usePage'
import { usePatient } from '../../providers/PatientProvider'

const Consents: React.FC = () => {
  const page = usePage()
  const patient = usePatient()
  const { t } = useTranslation()
  const answers = useAnswers()

  const handleSubmit = (values: Partial<Form>) => {
    return page.onSubmit(values)
  }

  const subtitle = (() => {
    const showConsentsSubtitle =
      !patient?.data?.optins?.confidentialityAgreementAccepted ||
      !patient?.data?.optins?.marketingCommunicationConsentAccepted

    if (showConsentsSubtitle) {
      return 'subltitle.headline1.consents'
    }

    return 'subltitle.headline2.cancelation_only'
  })()

  const dataProtectionUrl = ClinicEntity.getDataProtectionUrl(patient?.data?.clinic)

  return (
    <PageLayout title={t('category.finalize')} subtitle={t(subtitle)}>
      <ConsentsForm
        {...page}
        privacyPolicyUrl={dataProtectionUrl}
        initialValues={{ ...answers }}
        optins={patient?.data?.optins}
        loading={false}
        onSubmit={handleSubmit}
        clinicReferenceId={patient?.data?.clinic?.referenceId}
        anaBackendUrl={process.env.REACT_APP_API_URL}
      />
    </PageLayout>
  )
}

export default Consents
